/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col, Divider, Form, Input } from 'antd';

import { MESSAGES } from '@translations/labels';
import ModalStyles from './saveVersionModalContentStyles';

const labels = {
  ...MESSAGES.conversationHistory.modalReassignIntent,
  ...MESSAGES.manageBot.releasesPage,
  searchPlaceholder: MESSAGES.manageBot.searchIntentPlaceholder,
};

const SaveVersionModalContent = ({ settings }) => {
  const [saveVersionform] = Form.useForm();

  const cancelModal = () => {
    settings.onCancel();
  };

  const handleSubmit = (values) => {
    console.log('handleSubmit > values ->', values);
    settings.onOk(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <>
      <Form
        name="save-version-form"
        layout="vertical"
        form={saveVersionform}
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}
      >
        <div className="save-version-modal-content">
          <Row style={{ alignItems: 'flex-end' }}>
            <h4 className="uppercase">
              Setup a new {settings.resourceType} version
            </h4>
          </Row>

          <Row id={'modal-description'} style={{ alignItems: 'flex-end' }}>
            This will create an snapshot of the current {settings.resourceType}
          </Row>

          <Row style={{ alignItems: 'flex-end' }}>
            <Col>
              <Form.Item
                name="versionName"
                rules={[
                  {
                    required: true,
                    message: 'mandatory field',
                  },
                  {
                    pattern:
                      /^[a-zA-Z]{1}[a-zA-Z0-9]+((( |-|_)+[a-zA-Z0-9]+)+)?$/,
                    message:
                      'Use letters, numbers, spaces , -  and _ , starting with a letter and ending with a letter or a number',
                  },
                  {
                    min: 4,
                    message: 'Use a minimun of 4 characters',
                  },
                  {
                    max: 55,
                    message: 'You can add more details in the description',
                  },
                ]}
                style={{ marginBottom: 0 }}
                label={<strong>Version name</strong>}
              >
                <Input
                  placeholder={'Type a name for this version'}
                  autoComplete="off"
                  maxLength="56"
                  showCount
                  style={{ width: 550 }}
                  allowClear
                />
              </Form.Item>
            </Col>
          </Row>

          <Row style={{ alignItems: 'flex-end' }}>
            <Col>
              <Form.Item
                name="versionDescription"
                rules={[
                  {
                    required: true,
                    message: 'mandatory field',
                  },
                ]}
                style={{ marginBottom: 0 }}
                label={<strong>Version description</strong>}
              >
                <Input.TextArea
                  placeholder={'Type a description for this version'}
                  autoComplete="off"
                  maxLength="140"
                  showCount
                  style={{ width: 550 }}
                  allowClear
                />
              </Form.Item>
            </Col>
          </Row>
        </div>

        <Divider />
        <div className="save-version-modal-footer-btns">
          <Button
            onClick={cancelModal}
            className="uppercase"
            style={{ border: 'none' }}
          >
            Cancel
          </Button>
          <Form.Item>
            <Button
              htmlType="submit"
              type="primary"
              className="uppercase ok-button"
            >
              {settings.okText}
            </Button>
          </Form.Item>
        </div>
      </Form>
      <style jsx>{ModalStyles}</style>
    </>
  );
};

SaveVersionModalContent.propTypes = {
  settings: PropTypes.object,
};

export { SaveVersionModalContent };
